import { Skeleton } from '@/components/ui/skeleton';
import { useFollowUpSettings, useSaveFollowUpSettings } from '@/hooks/queries';
import { FollowUpSettingsForm } from './FollowUpSettingsForm';
import { FundraisingPage } from './FundraisingPage';

/**
 * The Fundraiser's follow-up settings page: the eight drafts callers send during and after a call, and where
 * {link} points. Callers' phones pick up a save on their next drafts fetch — no app release.
 */
export function FollowUpSettingsEditor() {
  const settings = useFollowUpSettings(undefined);
  const { mutate: save, isPending, failure } = useSaveFollowUpSettings();

  return (
    <FundraisingPage tab="follow-ups">
    <div className="max-w-5xl space-y-6">
      <div>
        <p className="text-[13px] text-muted-foreground">
          The texts and emails callers send from their own phone during and after a call. Use {'{first_name}'},{' '}
          {'{amount}'}, {'{link}'} and {'{candidate}'} to make each one personal.
        </p>
      </div>

      {(settings.status === 'loading' || settings.status === 'idle') && (
        <div className="space-y-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-40 w-full" />
          ))}
        </div>
      )}
      {(settings.status === 'failed' || settings.status === 'offline') && (
        <p role="status" className="text-sm text-muted-foreground">
          {settings.status === 'offline'
            ? "You're offline, so the follow-up settings can't load."
            : 'We couldn\u2019t load the follow-up settings right now.'}
        </p>
      )}
      {settings.status === 'ready' && (
        // Remount on each saved version so the form shows the server's copy and sends the fresh token.
        <FollowUpSettingsForm
          key={settings.data.concurrencyVersion}
          settings={settings.data}
          onSave={(request) => save(request)}
          saving={isPending}
          error={failure?.message ?? null}
        />
      )}
    </div>
    </FundraisingPage>
  );
}
